<template>
  <section>

    <div class="filter-top">
      <!--      <span>Search</span>-->
      <div
        v-if="!isAccount"
        class="mg-b-30">
        <v-radio-group
          v-model="merchant_platform"
          button
          :list="serverTypeOption"
          @change="filterData"></v-radio-group>
      </div>
      <v-input
        v-model="search"
        :prefixIcon="'el-icon-search'"
        placeholder="ID,Customer Name,Contact,Referrer Name,Price,ID No."
        @keyEnter="filterData" />
    </div>

    <div
      class="filter-bar pointer"
      :class="{
        'blue-bg': diff,
        'border-bottom-radius': !showFilterCard}"
      @click="handleShowFilter">
      <div class="main-left">
        <div class="left">
          <font-awesome-icon
            icon="filter"
            class="icon icon-filter"></font-awesome-icon>
          <span class="text">Filter</span>
        </div>
        <div class="filter-status">
          <span
            v-for="(item, i) in statusList"
            :key="i"
            class="status-item">
            <span class="status-title">
              {{item.title}}:
            </span>
            <span class="content">
              {{item.content}}
            </span>
          </span>
        </div>
      </div>
      <div class="right">
        <div
          v-if="diff"
          class="translucence"></div>
        <div class='right-content'>
          <font-awesome-icon
            v-show="diff"
            icon="rotate-left"
            class="icon icon-rotate pointer"
            @click.stop="resetFilter"></font-awesome-icon>
          <font-awesome-icon
            v-if="showFilterCard"
            icon="square-minus"
            class="icon pointer"
          ></font-awesome-icon>
          <font-awesome-icon
            v-else
            icon="square-plus"
            class="icon pointer"
          ></font-awesome-icon>
        </div>
      </div>
    </div>
    <div
      v-show="showFilterCard"
      class="filter-card border-bottom-radius">
      <div class="filter-main">
        <div class="filter-left">
          <div class="form-item">
            <span>Created</span>
            <v-date-picker
              v-model="date"
              type="daterange"
              @change="filterData" />
          </div>
          <div
            v-if="!isAccount"
            class="form-item">
            <span>Effective Start Date</span>
            <v-date-picker
              v-model="effective_date"
              type="daterange"
              @change="filterData" />
          </div>
          <div class="form-item">
            <span>
              Insurer
            </span>
            <span>
              <v-select
                v-model="company_id"
                :list="insurerList"
                @change="filterData" />
            </span>
          </div>
          <div class="form-item">
            <span>
              Agency
            </span>
            <v-select
              v-model="agency_search_id"
              :list="agencyStatusOption"
              placeholder="All"
              multiple
              @change="filterData">
              <template  v-slot:default="{item}">
                <span class="flex-align-center">
                  <span class="table-icon__img mg-r-8">
                    <img :src="item.agency_icon">
                  </span>
                  <span> {{item.name}}</span>
                </span>
              </template>
            </v-select>
          </div>
          <div class="form-item">
            <span>
              Channel
            </span>
            <span>
              <v-select
                v-model="source"
                :list="specialOptions.source"
                placeholder="All"
                multiple
                @change="filterData"
              />
            </span>
          </div>
          <div
            v-if="!isAccount"
            class="form-item">
            <span>
              Partner
              <span
                v-if="partner_filter_id.length"
                class="all"
                @click="handlerNoneAll('partner_filter_id')">None</span>
            </span>
            <span>
              <v-select
                v-model="partner_filter_id"
                placeholder="All"
                multiple
                :list="partnerList"
                @change="filterData" />
            </span>
          </div>
          <div
            v-if="!isAccount"
            class="form-item">
            <span>
              Referrer
            </span>
            <span>
              <v-input
                v-model="referrer_code"
                @change="filterData" />
            </span>
          </div>

        </div>
        <div class="filter-middler">
          <div class="form-item">
            <span>
              Product Type
              <span
                class="all"
                @click="handlerSelectAll('class_id')"> All</span>
              <span
                class="all"
                @click="handlerNoneAll('class_id')">None</span>
            </span>
            <div class="flex">
              <div class="half">
                <span>Auto-Quote</span>
                <v-checkbox
                  v-model="motor_select"
                  class="mg-t-8 mg-b-10"
                  :is-indeterminate="isAllMotorSelect"
                  @change="handleSelectQuote"><span class="fs-14 color-dark fw-600">Motors</span></v-checkbox>
                <v-checkbox-group
                  v-model="class_id"
                  :list="motorClassOptions"
                  :isColumn="false"
                  @change="filterData"></v-checkbox-group>
                <v-checkbox
                  v-model="none_motor_select"
                  class="mg-t-8 mg-b-10"
                  :is-indeterminate="isNoneMotorSelect"
                  @change="handleSelectNoneQuote"><span class="fs-14 color-dark fw-600">Non-Motors</span></v-checkbox>
                <v-checkbox-group
                  v-model="class_id"
                  :list="noneMotorClassOptions"
                  :isColumn="false"
                  @change="filterData"></v-checkbox-group>
              </div>
              <div class="half mg-t-20">
                <v-checkbox
                  v-model="sme_select"
                  class="mg-t-8 mg-b-10"
                  :is-indeterminate="isSMESelect"
                  @change="handleSelectSMEQuote"><span class="fs-14 color-dark fw-600">SME</span></v-checkbox>
                <v-checkbox-group
                  v-model="class_id"
                  :list="sme_class_data"
                  :isColumn="false"
                  @change="filterData"></v-checkbox-group>
              </div>
              <!--              <div class="half">-->
              <!--                <span>SME</span>-->
              <!--                <v-checkbox-group-->
              <!--                  v-model="product_id"-->
              <!--                  :list="ticketOptions.categoryOptions"-->
              <!--                  :block="true"-->
              <!--                  @change="filterData"></v-checkbox-group>-->
              <!--              </div>-->
              <!-- <div class="half">
                <span>&nbsp;</span>
                <v-checkbox-group
                  v-model="product_id"
                  :list="ticketOptions.industryOptions"
                  :block="true"
                  @change="filterData"></v-checkbox-group>
              </div> -->
            </div>
          </div>
        </div>
        <div class="middle-right">
          <div class="form-item">
            <span>
              Type
              <span
                class="all"
                @click="handlerSelectAll('type')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('type')">None</span>
            </span>
            <v-checkbox-group
              v-model="type"
              :list="quoteTypeOptions"
              :isColumn="false"
              @change="filterData">
              <template #default="{ item }">
                <span class="flex">
                  <span  class="button-border">{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
          <div class="form-item">
            <span>
              Status
              <span
                class="all"
                @click="handlerSelectAll('stts')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('stts')">None</span>
            </span>
            <v-checkbox-group
              v-model="stts"
              :list="quoteStautsOption"
              :isColumn="false"
              @change="filterData">
              <template #default="{ item }">
                <span class="flex">
                  <span
                    class="circle"
                    :class="{
                      'yellow-dark': [4, 7].includes(item.id),
                      'blue': [1, 5].includes(item.id),
                      'green': [10].includes(item.id),
                      'red': [6].includes(item.id),
                      'purple': [3, 8].includes(item.id),
                      'orange-light': [9].includes(item.id)
                    }"></span>
                  <span>{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
          <div class="form-item">
            <span>
              Account
            </span>
            <v-checkbox-group
              v-model="hav_account"
              :list="policy_account_option"
              :isColumn="false"
              @change="filterData">
              <template #default="{ item }">
                <span class="flex-align-center">
                  <p class="icon icon-text">
                    <i
                      v-if="item.id==1"
                      class="el-icon-user-solid gray fs-16 icon-color"></i>
                    <i
                      v-if="item.id==2"
                      class="el-icon-user gray fs-16 icon-color"></i>
                  </p>
                  <span
                    class="span-options span-options__none gray">{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
        </div>
        <div class="filter-right">
          <div class="form-item">
            <span>
              Tags
              <span
                class="all"
                @click="handlerSelectAll('tags')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('tags')">None</span>
            </span>
            <v-checkbox-group
              v-model="tags"
              :list="specialOptions.quote_tag"
              :isColumn="false"
              @change="filterData">
              <template #default="{ item }">
                <span class="flex">
                  <span
                    class="span-options"
                    :class="{
                      'gray': [2,4,8].includes(item.id),
                      'red': [1].includes(item.id),
                    }">{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
          <div class="form-item">
            <span>
              Application Type
              <span
                class="all"
                @click="handlerSelectAll('application_type')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('application_type')">None</span>
            </span>
            <v-checkbox-group
              v-model="application_type"
              :list="applicationTypeOption"
              :isColumn="false"
              @change="filterData">
            </v-checkbox-group>
          </div>
        </div>
      </div>
    </div>
    <div class="transparent">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-row-class-name="'tableHeader'"
        @row-click="rowClick">
        <el-table-column
          width="60"
          align="center">
          <template #default="{ row }">
            <div class="flex-algin  flex-align-center">
              <span
                v-if="row.merchant_platform"
                class="table-icon__img">
                <img :src="getOptionName('serverTypeIcon',row.merchant_platform)" >
              </span>
              <span
                v-tooltip="row.agency_name"
                class="table-icon__img mg-t-8">
                <img
                  :src="getAgencyIcon(row.agency_id)" >
              </span>
              <span class="mg-t-8">
                <font-awesome-icon
                  class="fs-16"
                  icon="dollar-sign" />
              </span>
              <p></p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="quote_dt"
          width="100"
          label="Created">
          <!--          <template #default="{ row }">-->
          <!--            <div class="flex-algin" >-->
          <!--              <span>{{row.quote_dt}}</span>-->
          <!--            </div>-->
          <!--          </template>-->
          <template #default="{ row }">
            <div class="text">
              <span>{{ row.quote_dt.split(" ")[0] }}</span><br>

              <span> {{ row.quote_dt.split(" ")[1] }}</span>
              <p class="channel">{{row.source_language}}</p>
            </div>
          </template>
        </el-table-column>
        <!--        <el-table-column-->
        <!--          prop="id"-->
        <!--          label="ID"></el-table-column>-->

        <el-table-column
          width="145"
          align="left"
          prop="id"
        >
          <template #default="{ row }">
            <span class="button-border table-type">{{row.type_language}}</span>
            <p v-if="row.application_type"><span class="button-border table-type">{{row.application_type}}</span></p>
            <div
              class="flex-align-center margin-top-flex"
            >
              <span
                v-if="row.company_id&&row.product_id!=80||row.sme_versions==3"
                v-tooltip="row.company_id>0?row.company_language:null"
                class="icon icon-content"
              >
                <img
                  v-if="row.company_id>0"
                  :src="getOptionData('companySmallIcon', row.company_id).logo? getOptionData('companySmallIcon', row.company_id).logo: row.company_logo"
                >
              </span>
              <span>
                <span
                  v-tooltip="row.class_language"
                  class="icon icon-content"
                >
                  <font-awesome-icon
                    v-if="row.class_id&&row.product_id!=80||row.sme_versions==3"
                    :icon="getOptionName('iconOptions', row.class_id)" />
                  <font-awesome-icon
                    v-else
                    icon="cube" />
                </span>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          min-width="200"
          label="Plan Name">
          <template #default="{ row }">
            <div
              class="flex-algin"
            >
              <router-link
                class="showLick plan"
                :class="{'italic': row.plan_id === null}"
                :to="rowClickFn(row)">
                {{ row.plan }}
              </router-link>
              <!-- <p>{{row.plan}}</p> -->
              <p  class="liter-text">{{row.quotation_number}}</p>
            </div>
          </template>
        </el-table-column>
        <!--        <el-table-column-->
        <!--          width="150"-->
        <!--          label="Agency">-->
        <!--          <template #default="{ row }">-->
        <!--            <div class="flex-algin">-->
        <!--              <span class="first-text">{{ row.agency_nickname }}</span>-->
        <!--            </div>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <el-table-column
          width="100"
          prop="price"
          label="Price">
          <template #default="{ row }">
            <div class="flex-algin">
              <span>{{row.price}}</span>
              <p></p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="125"
          prop="contact_nm"
          label="Policyholder">
          <template #default="{ row }">
            <div class="flex-algin">
              <span
                class="word-break"
                :class="{
                  'unname': row.contact_nm.trim() == ''
                }">
                {{ row.contact_nm.trim()?  row.contact_nm : 'Unnamed Account'}}
              </span>
              <p  class="liter-text"><i :class="row.customer_id>0?'el-icon-user-solid':'el-icon-user'"/> {{ row.phone_no }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="120"
          prop="referrer_nm"
          label="Referrer">
          <template #default="{ row }">
            <span
              v-if="row.referrer_id != 0 && row.referrer_nm.trim() === ''"
              class="unname">Unnamed</span>
            <span v-if="row.referrer_id != 0">{{ row.referrer_nm }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="120"
          label="Period">
          <template #default="{row}">
            <div
              v-if="row.policy_period"
              class="flex-column">
              <span>{{row.policy_period.split(" - ")[0]}} - </span>
              <span>{{row.policy_period.split(" - ")[1]}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="190"
          prop="stts_language"
          label="Status">
          <template #default="{ row }">
            <div class="flex-algin">
              <span>
                <span
                  class="span-status"
                  :class="getStatusColor(row.stts_language,'quoteStatusColor')">
                  {{ row.stts_language }}
                </span>
              </span>
              <span
                v-for="(v,i) in row.tag_language"
                :key="i">
                <span
                  class="span-options"
                  :class="{
                    'red': [1].includes(v.id),
                    'gray': [2,4,8].includes(v.id)
                  }">
                  {{ v.name }}
                </span>
              </span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {getOrderList} from '@/api/order'
import {mapActions, mapState} from 'vuex'
import {getAccountQuoteList} from '@api/account'
import MixinProductTypeFilter from '@/mixins/product-type-filter'

export default {
  name: 'Quotes',

  mixins: [MixinOptions,MixinProductTypeFilter],
  props:{
    customerId:{
      type:[String,Number],
      default:''
    },
    isAccount:{
      type:Boolean,
      default:false,
    },
    isFina:{
      type:Boolean,
      default:false,
    }
  },
  data() {
    return {
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      // // todo
      // statusOptions: [
      //   {
      //     name: 'Quick Quote',
      //     id: 1
      //   },
      //   {
      //     name: 'Paid',
      //     id: 2
      //   }
      // ],
      merchant_platform:'',
      date: [],
      product_id: [],
      company_id: 0,
      type: [],
      stts: [],
      agency_search_id: [],
      search: '',
      tableData: [],
      tags: [],
      statusList: [],
      showFilterCard: true,
      source: [],
      referrer_code: '',
      partner_filter_id: [],
      effective_date: [],
      application_type:[],
      hav_account: [],
      defaultFilter:{
        date: [],
        company_id: 0,
        class_id: [],
        type: [],
        stts: [],
        agency_search_id: [],
        tags: [],
        source: [],
        partner_filter_id: [],
        effective_date: [],
        merchant_platform:'',
        application_type:[],
        hav_account: [],
      }
    }
  },
  computed:{
    ...mapState('filter', ['selectFilterData','openFilterCar']),
    ...mapState('account', ['customerFilter']),
    policy_account_option() {
      return this.globalOptions.policy_account_option
    },
    tagsOptions(){
      return this.specialOptions.quote_tag || []
    },
    channelList(){
      return this.specialOptions.source || []
    },
    partnerList(){
      return this.globalOptions.policy_partner_filter || []
    },
    insurerList(){
      let arr = JSON.parse(JSON.stringify(this.insurerAllOptions))
      arr.unshift({id: 0, name: 'All'})
      return arr
    },
    diff(){
      let res = false
      Object.keys(this.defaultFilter).forEach(key => {
        let vue_data = JSON.parse(JSON.stringify(this[key]))
        let default_data = JSON.parse(JSON.stringify(this.defaultFilter[key]))
        if(Array.isArray(vue_data) && Array.isArray(default_data)){
          vue_data.sort()
          default_data.sort()
        }
        if(JSON.stringify(vue_data) != JSON.stringify(default_data)){
          res =  true
        }
      })
      return res
    },
    classTypeOptions(){
      return this.globalOptions.class_data.filter(item => item.id != 90) || []
    },
    classOptions(){
      let arr = this.classTypeOptions
      let data = []
      // data = index==1? arr.filter(item =>item.id>50): arr.filter(item =>item.id<50)
      data = arr.filter(item =>item.id<50)
      return data
    },
    sme_class_data(){
      let {sme_class_data} = this.globalOptions||{}
      return sme_class_data||[]
    },
    all_class_data(){
      return [...this.classOptions,...this.sme_class_data]
    }
  },
  watch: {
    property: {
      immediate: true,
      handler() {
        if(this.isAccount){
          let {quote={}} =  this.customerFilter||{}
          Object.keys(quote).forEach(item=>{
            this[item] = quote[item]
          })
          this.network().getAccountQuoteList()
        }
        else{
          let {quote={}} =  this.selectFilterData||{}
          Object.keys(quote).forEach(item=>{
            this[item] = quote[item]
          })
          this.setFilterData(quote)
          let filterCar =  this.openFilterCar||{}
          let {showFilterCard=true} = filterCar.quote||{}
          this.showFilterCard = showFilterCard
          this.network().getOrderList()
        }
      }
    },
    date: {
      immediate: true,
      handler(val){
        this.delStatus('Created')
        if(val && val.length){
          let content = val[0] + ' - ' + val[1]
          this.addStutus('Created', content)
        }
      }
    },
    company_id:{
      immediate: true,
      handler(val){
        this.delStatus('Insurer')
        if(val){
          let company = this.getOptionName('insurerList',val)
          this.addStutus('Insurer', company)
        }
      }
    },
    source:{
      immediate: true,
      handler(val){
        this.delStatus('Channel')
        if(val.length){
          let status = []
          val.forEach(item => {
            status.push(this.getOptionName('channelList', item))
          })
          this.addStutus('Channel', status.join(', '))
        }
      }
    },
    class_id:{
      immediate: true,
      handler(val){
        this.delStatus('Product Type')
        if(val.length){
          this.addStutus('Product Type', `${val.length} Products`)
        }
      }
    },
    type:{
      immediate: true,
      handler(val){
        this.delStatus('Type')
        if(val.length){
          let status = []
          val.forEach(item => {
            status.push(this.getOptionName('quoteTypeOptions', item))
          })
          this.addStutus('Type', status.join(', '))
        }
      }
    },
    stts:{
      immediate: true,
      handler(val){
        this.delStatus('Status')
        if(val.length){
          let status = []
          val.forEach(item => {
            status.push(this.getOptionName('quoteStautsOption', item))
          })
          this.addStutus('Status', status.join(', '))
        }
      }
    },
    tags:{
      immediate: true,
      handler(val){
        this.delStatus('Tags')
        if(val.length){
          this.addStutus('Tags', `${val.length} Tags`)
        }
      }
    },
  },
  destroyed() {
    const vcTooltipDom = document.getElementById('vc-tooltip')
    vcTooltipDom && document.body.removeChild(vcTooltipDom)
  },
  methods: {
    ...mapActions('quote', ['setIsBack']),
    ...mapActions('filter', ['setFilterData','setOpenFilterCar']),
    ...mapActions('account', ['setCustomerFilter']),
    getAgencyIcon(agency_id){
      let obj = {}
      this.agencyStatusOption.filter(item=>{
        if(item.id==agency_id)
          obj = item
      })
      return obj.agency_icon
    },
    handleShowFilter(){
      this.showFilterCard = !this.showFilterCard
      this.setOpenFilterCar({
        ...this.openFilterCar,
        quote:{
          showFilterCard:this.showFilterCard
        }
      })
    },
    rowClick(row) {
      //filter
      let params = {
        class_id:this.class_id,
        company_id:this.company_id,
        type:this.type,
        stts:this.stts,
        search: this.search,
        pageConfig:this.pageConfig,
        date:this.date,
        tags: this.tags,
        source: this.source,
        merchant_platform:this.merchant_platform,
        agency_search_id:this.agency_search_id,
        application_type:this.application_type,
        hav_account:this.hav_account,
      }
      this.setFilterData({quote:params})
      this.setIsBack(null)
      let product_id = row.product_id
      let {sme_versions} = row
      if(row.product_id==80&&sme_versions!=3)
        product_id = row.class_id
      this.$router.push({
        path: '/records/quote/detail',
        query: {
          order_id: row.id,
          product_id: product_id,
          // sme_versions
        }
      })
      if(this.isAccount){
        this.setCustomerFilter({
          quote: params
        })
      }
    },
    // 新标签打开链接
    rowClickFn(row){
      let product_id = row.product_id
      let {sme_versions} = row
      if(row.product_id==80&&sme_versions!=3)
        product_id = row.class_id
      this.setIsBack(null)
      return({
        path: '/records/quote/detail',
        query: {
          order_id: row.id,
          product_id:product_id,
          // sme_versions
        }
      })
    },
    handlerSelectAll(target) {
      let origin = ''
      switch(target) {
        case 'class_id':
          origin = 'all_class_data'
          break
        case 'stts':
          origin = 'quoteStautsOption'
          break
        case 'company_id':
          origin = 'insurerAllOptions'
          break
        case 'type':
          origin = 'quoteTypeOptions'
          break
        case 'tags':
          origin = 'tagsOptions'
          break
        case 'source':
          origin = 'channelList'
          break
        case 'agency_search_id':
          origin = 'agencyStatusOption'
          break
        case 'application_type':
          origin = 'applicationTypeOption'
          break
      }
      const data = this[origin].reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      this[target] = data
      if(target=='class_id'){
        this.sme_select = true
        this.none_motor_select = true
        this.motor_select = true
      }
      this.filterData()
    },
    handlerNoneAll(target){
      this[target] = []
      if(target=='class_id'){
        this.sme_select = false
        this.none_motor_select = false
        this.motor_select = false
      }
      this.filterData()
    },
    filterData() {
      this.pageConfig.currentPage = 1
      if(this.isAccount)
        this.network().getAccountQuoteList()
      else{
        this.network().getOrderList()
      }
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      if(this.isAccount)
        this.network().getAccountQuoteList()
      else{
        this.network().getOrderList()
      }
    },
    addStutus(title,content){
      this.statusList.push({
        title,
        content
      })
    },
    delStatus(title){
      // 把符合删除条件的元素都过滤掉
      let arr = []
      arr = this.statusList.filter(item => {
        return item.title !== title
      })
      this.statusList = JSON.parse(JSON.stringify(arr))
    },
    resetFilter(){
      Object.keys(this.defaultFilter).forEach(key => {
        this[key] = this.defaultFilter[key]
      })
      this.filterData()
    },
    network() {
      return {
        getOrderList: async () => {
          const { data } = await getOrderList({
            quote_dt_start: this.date[0],
            quote_dt_end: this.date[1],
            class_id: this.class_id,
            company_id: this.company_id == 0? null : [this.company_id],
            stts: this.stts,
            type: this.type,
            search: this.search,
            tag_id: this.tags,
            page: this.pageConfig.currentPage,
            source: this.source,
            partner_filter_id: this.partner_filter_id,
            referrer_code: this.referrer_code,
            cmnt_dt: this.effective_date[0],
            expry_dt: this.effective_date[1],
            merchant_platform:this.merchant_platform,
            agency_search_id:this.agency_search_id,
            application_type:this.application_type,
            hav_account:this.hav_account,
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
        },
        getAccountQuoteList: async () => {
          const { data } = await getAccountQuoteList({
            quote_dt_start: this.date[0],
            quote_dt_end: this.date[1],
            product_id: this.class_id,
            company_id: this.company_id == 0? null : [this.company_id],
            stts: this.stts,
            type: this.type,
            search: this.search,
            tag_id: this.tags,
            page: this.pageConfig.currentPage,
            customer_id: this.customerId,
            source: this.source,
            partner_filter_id: this.partner_filter_id,
            referrer_code: this.referrer_code,
            cmnt_dt: this.effective_date[0],
            expry_dt: this.effective_date[1],
            merchant_platform:this.isFina?2:1,
            agency_search_id:this.agency_search_id,
            application_type:this.application_type,
            hav_account:this.hav_account,
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  position: relative;
  color: #303133;
  .filter-top{
    margin-bottom: 30px;
  }
  .btn-top-container {
    position: absolute;
    top: 10px;
    right: 0;
  }
  h1 {
    // margin-bottom: 20px;
    font-size: 34px;
  }
  .filter-container {
    .filter-box {
      margin-bottom: 10px;
      .label {
        display: block;
        padding-bottom: 5px;
        font-size: 14px;
        font-weight: bold;
        .all {
          display: inline-block;
          padding-left: 15px;
          color: #409eff;
          font-weight: 500;
          cursor: pointer;
        }
      }
      .search-box {
        margin-right: 20px;
        width: 400px;
      }
      .quote-box {
        width: 300px;
      }
    }

  }
  .span-name {
    display: block;
    color: #24292E;
  }
  .span-label {
    display: block;
    color: #24292E;
    font-weight: 500;
  }
  .half {
    width: 100%;
    & > span {
      display: block;
      padding-bottom: 5px;
      font-size: 14px;
      color: #6a737d;
    }
  }
  .span-status {
    display: inline-block;
    margin-right: 15px;
    padding: 5px 10px;
    border-radius: 12px;
    font-size: 12px;
    line-height: 14px;
    color: white;
    font-weight: 500;
    .svg-inline--fa {
      margin-right: 5px;
      font-size: 14px;
    }
    &.green {
      background: #28a745;
      color: white;
    }
    &.orange {
      background: #E36209;
      color: white;
    }
    &.yellow-dark {
      background: #DBAB09;
    }
    &.yellow{
      background: #DBAB09;
    }
    &.blue {
      background: #0366D6;
    }
    &.pending {
      background: #0366D6;
    }
    &.red {
      background: #d73a49;
    }
    &.void {
      background: #d73a49;
    }
    &.min-green {
      background: #dcffe4;
      color: #28a745;
    }
  }
  .span-options {
    display: inline-block;
    padding: 0px 8px;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #FFFFFF;
    border-radius: 100px;
    max-width: 140px;
    word-break:keep-all;
    white-space:nowrap;
    height: 18px;
    min-height: 18px !important;
    border: 1px solid;
    &.gray {
      border-color: #586069;
      color: #586069;
    }
    &.red {
      border-color: #D73A49;
      color: #D73A49;
    }
  }
  .filter-bar{
    border: 1px solid #D1D5DA;
    height: 46px;
    padding: 11px 16px;
    background: #FFFFFF;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    white-space: nowrap;
    .icon{
      font-weight: 900;
      font-size: 14px;
      color: #586069;
    }
    .main-left{
      display: flex;
      overflow: hidden;
    }
    .left{
      margin-right: 15px;
      .icon-filter{
        margin-right: 11px;
      }
      .text{
        font-weight: 600;
        font-size: 14px;
      }
    }
    .filter-status{
      .status-item{
        height: 24px;
        padding: 4px 8px;
        background: #F1F8FF;
        border-radius: 100px;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        color: #0366D6;
        .content{
          font-weight: 600;
        }
        & + .status-item{
          margin-left: 18px;
        }
      }
    }
    .right{
      display: flex;
      align-items: center;
      position: relative;
      padding-left: 16px;
      .translucence{
        position: absolute;
        right: 100%;
        width: 15px;
        height: 44px;
        background: linear-gradient(90deg, rgba(219, 237, 255, 0) 0%, #DBEDFF 100%);
      }
      .right-cotent{
        background: #DBEDFF;
      }
      .icon-rotate{
        margin-right: 18px;
        color: #0366D6;
      }
    }
    &.blue-bg{
      background: #DBEDFF;
    }
  }
  .border-bottom-radius{
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  .filter-card {
    margin-bottom: 30px;
    background: white;
    border: 1px solid #D1D5DA;
    border-top: none;
    .filter-top {
      display: flex;
      align-items: center;
      padding: 15px;
      border-bottom: 1px solid #E1E4E8;
      & > span {
        display: inline-block;
        padding-right: 10px;
      }
    }
    .filter-main {
      display: flex;
      padding: 0 15px;
      .all {
        display: inline-block;
        padding-left: 15px;
        color: #409eff;
        cursor: pointer;
      }
      .filter-left, .filter-middler, .filter-right, .middle-right {
        padding: 15px 0;
      }
      .filter-left {
        padding-right: 10px;
        width: 290px;
      }
      .filter-middler {
        padding: 15px 10px;
        border-left: 1px solid #E1E4E8;
        border-right: 1px solid #E1E4E8;
        flex:1;
      }
      .middle-right{
        padding: 15px 10px;
        border-right: 1px solid #E1E4E8;
        flex: 1;
      }
      .filter-right {
        padding-left: 10px;
        flex:1;
      }
    }
    .circle {
      display: inline-block;
      margin-right: 5px;
      width: 14px;
      height: 14px;
      min-width: 14px;
      min-height: 14px;
      border-radius: 100%;
      &.orange-light {
        background: #E36209;
      }
      &.yellow-dark {
        background: #DBAB09;
      }
      &.blue {
        background: #0366D6;
      }
      &.green {
        background: #28A745;
      }

      &.red {
        background: #D73A49;
      }
    }
  }
  .purple {
    background: #6F42C1;
  }
  .transparent{
    margin-top: 15px;
  }
  ::v-deep .el-table{
    border-radius: 4px;
    border: 1px solid #E1E4E8;
  }
  ::v-deep .tableHeader {
    margin-top: 30px;
    background: #F6F8FA !important;
    border-bottom: 1px solid #E1E4E8;
    th {
      background-color: #F6F8FA !important;
      font-family: Inter;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      letter-spacing: -0.15px;
      /* Text/text-gray-dark */
      color: #24292E!important;
    }
  }
  .button-border{
    display: inline-block;
    padding: 0px 10px;
    height: auto;
    //line-height: 30px;
    font-size: 12px;
    border-radius: 50px;
    border: 1px solid #E1E4E8;
    color: #24292E;
    background: white;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;
    &.red {
      border-color: #D73A49;
      color: #D73A49;
    }
    &.gray {
      border-color: #586069;
      color: #586069;
    }
  }
  .table-type{
    white-space: nowrap;
  }
  .margin-top-flex{
    margin-top: 5px;
    .icon{
      margin-right: 10px;
      img{
        height: 22px;
        width: 22px;
      }
    }
    .icon-content{
      height: 22px;
      width: 22px;
      border-radius: 5px;
      background-color: #E1E4E8;
      color: #6A737D;
      font-size: 14px;
      text-align: center;
      line-height: 22px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #e1e4e8;
    }
  }
  .ju_center{
    justify-content: center;
  }
  .el-table{
    font-size: 12px;
    color: #24292E;
    ::v-deep .flex-algin{
      display: flex;
      flex-direction: column;
      justify-content:space-between ;
      p{
        height: 24px;
      }
      .unname{
        font-style: italic;
        color: #6A737D;
        white-space:nowrap;
      }
    }
    p:first-child{
      color: #24292E;
      font-size: 14px;
      font-weight: 500;
    }
    .login-text{
      color: #24292E;
      font-family: Inter;
      font-size: 14px;
      letter-spacing: 0;
      line-height: 17px;
    }
    .liter-text{
      color: #6A737D;
      font-family: Inter;
      font-size: 12px;
      letter-spacing: 0;
      line-height: 15px;
    }
    .text{
      color: #24292E;
    }
    .flex-column{
      display: flex;
      flex-direction: column;
    }
  }


}
.showLick{
  color: #24292E;
  text-decoration: none;
  font-weight: 600;
  &:hover{
    color:  #0366D6;
  }
  &.italic{
    font-style: italic;
  }
  &.plan{
    word-break: normal;
  }
}

.channel{
  color: #586069;
  font-weight: 600;
}
::v-deep .el-table{
  border-radius: 4px;
  border: 1px solid #E1E4E8;
  tr{
    td{
      padding: 10px 15px 10px 0!important;
      vertical-align: top;
      margin-right: 15px;
      .cell{
        line-height: 23px;
        position: relative;
        height: inherit;
        padding: 0;
      }
    }
  }
  th{
    .cell{
      padding: 0;
    }
  }
}
.table-icon__img{
  width: 22px;
  display: block;
  img{
    width: 22px;
  }
}
.word-break{
  word-break: break-word;
}
</style>
